import { useEffect, useRef } from "react";
import { toast } from "react-toastify";

const InternetWatcher = () => {
  const toastId = useRef(null);

  useEffect(() => {
    const handleOffline = () => {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Se perdió la conexión a internet", {
          autoClose: false, // que no se cierre solo
          closeOnClick: false,
          draggable: false,
        });
      }
    };

    const handleOnline = () => {
      if (toastId.current) {
        toast.dismiss(toastId.current);
      }
      toast.success("Conexión restablecida", {
        autoClose: 3000,
      });
    };

    // Si ya carga sin internet
    if (!navigator.onLine) {
      handleOffline();
    }

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  return null;
};

export default InternetWatcher;
